import {
  formatDateTime as formatDisplayDateTime,
  formatYearMonth,
  formatDate,
} from '@/shared/lib/dateFormat';

export const formatSettlementYearMonth = formatYearMonth;
export { formatDate };

export const getDefaultSettlementYm = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${now.getFullYear()}${month}`;
};

export const formatSettlementAmount = (value?: number | null): string => {
  if (value == null) return '-';
  return `₩${value.toLocaleString('ko-KR')}`;
};

/** 소수(0.12) 또는 퍼센트(12) 모두 허용 — 레거시 `* 100` 표시와 호환 */
export const formatCommissionRatePercent = (
  value?: number | null,
): string => {
  if (value == null || Number.isNaN(value)) return '0%';
  const percent = Math.abs(value) <= 1 ? value * 100 : value;
  return `${percent.toFixed(2)}%`;
};

export const formatBasicFeeType = (value?: string | null): string => {
  if (!value) return '-';
  return value === 'RANGE' ? '구간' : '고정';
};

export const formatDetailFeeApplied = (value?: boolean | null): string => {
  if (value == null) return '-';
  return value ? '적용' : '미적용';
};

export const formatPlatformFeeRatePercent = (
  value?: number | null,
): string => {
  if (value == null || Number.isNaN(value)) return '-';
  return `${Number(value).toFixed(2)}%`;
};

export type SettlementBadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline'
  | 'success'
  | 'warning'
  | 'info';

const normalizeStatusKey = (status?: string) =>
  String(status ?? '')
    .trim()
    .replace(/[\s_]+/g, '')
    .toLowerCase();

/**
 * 정산 승인 결과 태그 — SettlementUploadDetailPage / 라디오 필터 값과 동일 색 체계.
 */
export const getSettlementApprovalStatusMeta = (
  status?: string | null,
): { label: string; variant: SettlementBadgeVariant } => {
  const raw = status?.trim() || '';
  const key = normalizeStatusKey(raw);
  switch (key) {
    case '승인':
    case 'confirmed':
    case 'approved':
    case '제약사정산확정':
      return { label: raw || '승인', variant: 'success' };
    case '미등록거래처':
    case '흡수율미달':
    case '제약사확인요청':
      return { label: raw.replace(/_/g, ' ') || '미등록 거래처', variant: 'warning' };
    case '거래불가의약품':
    case '비거래약물':
      return {
        label: raw.replace(/_/g, ' ') || '거래 불가 의약품',
        variant: 'info',
      };
    case '최소금액기준미달':
    case '정산불가edi':
    case 'rejected':
      return {
        label: raw.replace(/_/g, ' ') || '최소금액기준 미달',
        variant: 'destructive',
      };
    case 'pending':
    case '대기':
      return { label: '대기', variant: 'secondary' };
    default:
      return { label: raw || '-', variant: 'outline' };
  }
};

export const formatDateTime = formatDisplayDateTime;
